import { Box } from '@node-space/ui-components'

export const Earn = () => {
  return <Box>Earn</Box>
}
